/**
 * Downloads the given blob with the given filename.
 * @param {Blob} blob
 * @param {string} filename
 */
export function downloadFile(blob, filename) {
  const aElement = document.createElement("a")
  aElement.download = filename
  aElement.href = window.URL.createObjectURL(blob)
  aElement.click()
}
